<template>
  <div class="row justify-content-center">
    <div class="col-12 col-sm-10 px-4">
      <div id="basic-info" class="card mt-4">
        <div class="card-body pt-0 invoice-card">

          <div class="row mb-3 p-3">
            <div class="row mb-3 p-3" v-if="olt_vpn.telnet">
            
            <div class="col-12 col-sm-3">
              <label>Telnet:</label><br>
              <input v-model="olt_vpn.telnet" type="text" class="rounded" readonly />
              <button @click="copyToClipboard('telnet')">Copy</button>
            </div>
            
            <div class="col-12 col-sm-3">
              <label>Snmp:</label><br>
              <input v-model="olt_vpn.snmp" type="text" class="rounded" readonly />
              <button @click="copyToClipboard('snmp')">Copy</button>
            </div>

            <div class="col-12 col-sm-3">
              <label>Http:</label><br>
              <input v-model="olt_vpn.http" type="text" class="rounded" readonly />
              <button @click="copyToClipboard('http')">Copy</button>
            </div>
            <div class="col-12 col-sm-3">
              <label>Https:</label><br>
              <input v-model="olt_vpn.https" type="text" class="rounded" readonly />
              <button @click="copyToClipboard('https')">Copy</button>
            </div>
          </div>

            <h5>Mikrotik Information</h5>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label d-flex">Mikrotik IP <span class="d-flex align-items-center mx-3" style="gap: 5px;">
                <input type="checkbox" v-model="formData.routerv7" id="routerv7-checkbox" />
                <label for="routerv7-checkbox" class="form-label mb-0">V7+</label>
              </span></label>
               <div :class="{'has-error': formData.Mikrotik_ip && isValidMPort == false, 'has-success': formData.Mikrotik_ip && isValidMPort == true}">
                <input
                  v-model="formData.Mikrotik_ip"
                  type="text"
                  placeholder="Mikrotik IP"
                  class="form-control invoice-card"
                />
              <span v-if="formData.Mikrotik_ip && isValidMPort == true" class="check-icon">&#10003;</span> 
                <span v-if="formData.Mikrotik_ip && isValidMPort == false" class="cross-icon">&#10007;</span> 
              </div>
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Mikrotik Username</label>
              <input
                v-model="formData.m_username"
                type="text"
                placeholder="Mikrotik Username"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Mikrotik Password</label>
              <input
                v-model="formData.m_password"
                type="text"
                placeholder="Mikrotik Password"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Mikrotik Api Port</label>
              <div :class="{'has-error': formData.m_port && isValidMPort == false, 'has-success': formData.m_port && isValidMPort == true}">
                <input
                  @change="PortCheck('microtic',formData.Mikrotik_ip, formData.m_port)"
                  v-model="formData.m_port"
                  type="text"
                  placeholder="Mikrotik Port"
                  class="form-control invoice-card"
                />
                <span v-if="formData.m_port && isValidMPort == true" class="check-icon">&#10003;</span> 
                <span v-if="formData.m_port && isValidMPort == false" class="cross-icon">&#10007;</span> 
              </div>
            </div>
            
            <br>
            <h5>Olt Information</h5>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">OLT Name</label>
              <input
                v-model="formData.olt_name"
                type="text"
                placeholder="OLT Name"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">OLT IP</label>
              <div :class="{'has-error': formData.olt_ip && isValidOltPort == false, 'has-success': formData.olt_ip && isValidOltPort == true}">
              <input
                v-model="formData.olt_ip"
                type="text"
                placeholder="OLT IP"
                class="form-control invoice-card"
              />
              <span v-if="formData.olt_ip && isValidOltPort == true" class="check-icon">&#10003;</span> 
                <span v-if="formData.olt_ip && isValidOltPort == false" class="cross-icon">&#10007;</span> 
              </div>
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">OLT Username</label>
              <input
                v-model="formData.olt_username"
                type="text"
                placeholder="OLT Username"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">OLT Password</label>
              <input
                v-model="formData.olt_password"
                type="text"
                placeholder="OLT Password"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">OLT Port</label>
              <div :class="{'has-error': formData.olt_port && isValidOltPort == false, 'has-success': formData.olt_port && isValidOltPort == true}">
              <input
                v-model="formData.olt_port"
                @change="PortCheck('olt',formData.olt_ip, formData.olt_port)"
                type="text"
                placeholder="OLT Port"
                class="form-control invoice-card"
              /> 
              <span v-if="formData.olt_ip && isValidOltPort == true" class="check-icon">&#10003;</span> 
                <span v-if="formData.olt_ip && isValidOltPort == false" class="cross-icon">&#10007;</span> 
              </div>
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Telnet Port</label>
              <input
                v-model="formData.telnet_port"
               
                type="text"
                placeholder="Telnet Port"
                class="form-control invoice-card"
              /> 
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Description</label>
              <input
                v-model="formData.description"
                type="text"
                placeholder="Description"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Branch</label>
              <select 
                class="form-control invoice-card" 
                v-model="formData.Branch_olt" 
              >
                <option 
                  v-for="(data, index) in branches" 
                  :key="index" 
                  :value="data.id"
                >
                  {{ data.name }}
                </option>
              </select>
            </div>

            <br>
            <h5>Notifications</h5>

            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Whatsapp Id</label>
              <input
                v-model="formData.wav_id"
                type="text"
                placeholder="Wav Id"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Telegram Id</label>
              <input
                v-model="formData.teleg_id"
                type="text"
                placeholder="Teleg Id"
                class="form-control invoice-card"
              />
            </div>
            <br>
            <h5>Others</h5>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Data Collection Ratio</label>
              <input
                v-model="formData.data_collcetratio"
                type="text"
                placeholder="Data Collcetratio"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Snmp Port</label>
              <input
                v-model="formData.snmp_port"
                type="text"
                placeholder="Snmp Port"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Db Alert Range</label>
              <input
                v-model="formData.db_allert_range"
                type="text"
                placeholder="Db Alert Range"
                class="form-control invoice-card"
              />
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Olt Modes</label>
              <select v-model="formData.olt_modes" name="" id="" class="form-control invoice-card">
                <option value="" selected disabled hidden>Select Olt Mode</option>
                <option v-for="(data,index ) in cat_data.olt_mode" :key="index" :value="data.id">{{data.olt_model}}</option>
              </select>
              
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Olt Brands</label>
              <select v-model="formData.olt_brands" name="" id="" class="form-control invoice-card">
                <option value="" selected disabled hidden>Select Olt Brand</option>
                <option v-for="(data,index ) in cat_data.olt_brand" :key="index" :value="data.id">{{data.olt_brand_name}}</option>
              </select>
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <label class="form-label">Billing</label>
              <select v-model="formData.olt_billing" class="form-control invoice-card required" name="" id="">
                  <option value="" selected disabled hidden>Select</option>
                  <option v-for="(item,index) in olt_data" :key="index" :value="item.id">{{item.olt_pack}}</option>
              </select>
            </div>            
          </div>
          
          <button
            class="float-end mb-0 btn btn-success"
            color="dark"
            variant="gradient"
            size="sm"
            @click="submitForm"

            :disabled="isValidMPort !=true || isValidOltPort !=true"
          >
            Add Olt <span v-if="loading" class="spinner-border spinner-border-sm mx-3"></span>
          </button>
          <button 
            class="float-end mb-0 btn btn-success mx-3"
            color="dark"
            variant="gradient"
            size="sm"
            @click="getOltVpnData"
          >
            Test Get Port <span v-if="loading_test" class="spinner-border spinner-border-sm mx-3"></span>
          </button>
            <router-link :to="{name:'OltList'}">
          <button
            class="float-end mx-3 mb-0 btn btn-secondary"
            color="dark"
            variant="gradient"
            size="sm"
          >
            Cancel
          </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import addOlt from "../services/add-olt.service";
import oltCatListData from "../services/olt-cat-list.service";
import NewOltDataFormListData from "../services/get-newolt-get-data-form.service";
import showSwal from "../mixins/showSwal.js";  
import getPortCheck from "../services/check-ports.service";
import getProfileCheck from "@/services/check-profile.service";
import getOltVpn from "../services/add-olt-vpn.service";
import { useUserApi } from "../services/user.service";
export default {
  data() {
    return {
      loading:false,
      loading_test:false,
      cat_data : [],
      olt_data : [],
      olt_vpn : [],
      branches : [],
      formData: {
        Mikrotik_ip: "",
        m_username: "",
        m_password: "",
        m_port: "",
        olt_ip: "",
        olt_username: "",
        olt_password: "",
        olt_port: "",
        description: "",
        Branch_olt: "",
        show: true,
        olt_name: "",
        login_user: "",
        olt_modes: "",
        olt_brands: "",
        olt_billing: "",
        wav_id: "",
        teleg_id: "",
        data_collcetratio: "",
        snmp_port: "",
        db_allert_range: "",
        telnet_port:"",
        routerv7: false
      },
       isValidMPort: null,
       isValidOltPort: null,
       fendy_user_id: ""
    };
  },
  mounted(){
    this.getData();
    this.getBranch();
    this.getNewOltDataForm();
    this.getCheckProfile();
    let user= JSON.parse(localStorage.getItem("user_data"));
    console.log(user.id)
    this.formData.login_user=user.id
  },
  methods: {
    async getBranch() {
      try {
        const response = await useUserApi().getBranchesData();
        this.branches = response;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
     copyToClipboard(field) {
      const textToCopy = this.olt_vpn[field];
      const tempInput = document.createElement('input');
      tempInput.value = textToCopy;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      showSwal.methods.showSwal({
          type: "success",
          message: `${field} copied!`,
          width: 450,
        });
    },
    async getCheckProfile() {
      try {
        let response = await getProfileCheck.getProfileCheck();
        this.fendy_user_id = response.fendy_user_id;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async getOltVpnData() {
      this.loading_test = true;
      this.olt_vpn = await getOltVpn.getOltVpn(this.fendy_user_id,this.formData.olt_ip);
      this.formData.telnet_port = this.olt_vpn.telnet_port;
      this.formData.snmp_port = this.olt_vpn.snmp_port;
      this.formData.olt_port = this.olt_vpn.http_port+'/'+ this.olt_vpn.https_port;
      this.formData.routerv7 = this.olt_vpn.routerv7;

      if(this.olt_vpn.error){
        showSwal.methods.showSwal({
            type: "error",
              message: "Please Connect VPN",
            }); 
      }else{
        showSwal.methods.showSwal({
            type: "success",
              message: "Test Success",
            });
      }
      this.loading_test = false;
    },
    async submitForm() {
      this.loading = true
      console.log("Form submitted with data:", this.formData);
      try {
          if(this.formData.olt_billing && this.formData.olt_billing != '' && this.formData.olt_billing != null){
            await addOlt.addData(this.formData);
            showSwal.methods.showSwal({
              type: "success",
                message: "Olt Created Successfully!",
            });
            this.$router.push("/olt-list");
          }else{
            showSwal.methods.showSwal({
            type: "error",
              message: "Please Provide Billing Information",
            }); 
            this.loading=false           
          }
        } catch (error) {        
        this.loading=false
        console.error("Error adding Olt:", error);
        showSwal.methods.showSwal({
          type: "error",
            message: "Failed to Create Olt!",
        });
        }
    },

    async PortCheck(type,ip,port){
                const response = await getPortCheck.getPortCheck(ip,port)
                console.log(response.status);
              if(type == 'microtic'){
                if(response.status == 'open'){
                  this.isValidMPort=true
                }else if(response.status == 'closed'){
                  this.isValidMPort=false
                }else{
                  this.isValidMPort=null
                }
              }else if(type == 'olt'){
                if(response.status == 'open'){
                  this.isValidOltPort=true
                }else if(response.status == 'closed'){
                  this.isValidOltPort=false
                }else{
                  this.isValidOltPort=null
                }
              }
                
            },

    async getData() {
                const response = await oltCatListData.getCatListData();
                this.cat_data = response;
            },
    async getNewOltDataForm() {
                const response = await NewOltDataFormListData.getNewOltDataFormListData();
                this.olt_data = response;
            },
  }
};
</script>
<style scoped>
.has-error .form-control {
  border: 1px solid red;
}
.has-success .form-control {
  border: 1px solid green;
}
.check-icon {
  color: green!important;
  position: absolute;
  right: 20px;
  top: 37px;
}
.cross-icon {
  color: red!important;
  position: absolute;
  right: 20px;
  top: 37px;
}
</style>
